APP.touristDetail = function () {
	const el = $('.tourist-detail');
	const touristSlider = el.find('.tourist-detail__slider');
	const slickFor = touristSlider.find('.slick--for');
	const slickNav = touristSlider.find('.slick--nav');

	function init() {
		if (el.length === 0) return;

		slickFor.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			draggable: false,
			swipe: false,
			asNavFor: '.slick--nav',
			responsive: [
				{
					breakpoint: 992,
					settings: {
						arrows: false,
						draggable: false,
						swipe: false,
					},
				},
			],
		});

		slickNav.slick({
			infinite: true,
			slidesToShow: 7,
			slidesToScroll: 1,
			asNavFor: '.slick--for',
			dots: false,
			arrows: false,
			centerMode: false,
			focusOnSelect: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
						infinite: false,
					},
				},
			],
		});
	}

	init();
};
